import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const maxeldConfig: TSPConfig = {
  key: 'maxeld',
  name: 'MaxELD',
  imageName: 'MaxELD',
  category: TSPCategory.CUSTOM,
  helpText:
    'Input the API Key you use to access MaxELD. Request an API Key from MaxELD support if you do not have one.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API Key',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default maxeldConfig;
